import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import { toast } from "react-toastify";
import { Grid, Paper } from "@mui/material";
import visa from './images/visaLogo.svg';
import discover from './images/discoverLogo.svg'
import mastercard from './images/mastercardLogo.svg'
import amex from './images/amexLogo.svg'
import { withTranslation } from "react-i18next";

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        height: 100,
        width: 350,
        padding: '15px',
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center'
    },
    noPaymentFound: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '16px',
        fontWeight: 500
    }
});

class PatientHistory extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            paymentMethods: [],
            isPaymentMethodsFound: true
        };
    }

    componentDidMount() {
        this.BindPaymentMethods();
    }

    BindPaymentMethods() {
        let patientId = this.props && this.props.patient && this.props.patient.id;
        if (patientId) {
            this.setState({ loader: true, data: null });
            fetch(process.env.REACT_APP_BASEURL + 'get/payment-methods/' + patientId, {
                method: 'GET',
                withCredentials: true,
                headers: {
                    'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
                    'Content-Type': 'application/json'
                },
            }).then(response => {
                try {
                    return response.json();
                } catch (error) {
                    return null;
                }
            }).then(paymentMethodResponse => {
                if (paymentMethodResponse && paymentMethodResponse.status === 404) {
                    this.setState({ isPaymentMethodsFound: false });
                } else if ((paymentMethodResponse && paymentMethodResponse.status === 400) || (paymentMethodResponse && paymentMethodResponse.status === 500)) {
                    toast.error(paymentMethodResponse.message);
                } else if (paymentMethodResponse && paymentMethodResponse.status === 200) {
                    this.setState({ paymentMethods: paymentMethodResponse._paymentMethods });
                }
            });
        }
    }

    getCardImageByCardBrand = (cardBrand) => {
        let brand = cardBrand.toString().toLowerCase();
        switch (brand) {
            case 'visa':
                return (<img src={visa} style={{ width: '70px' }} alt={brand} />);
            case 'discover':
                return (<img src={discover} style={{ height: '20px' }} alt={brand} />);
            case 'mastercard':
                return (<img src={mastercard} style={{ width: '20px' }} alt={brand} />);
            case 'american express':
                return (<img src={amex} style={{ width: '70px' }} alt={brand} />);
            default:
                return null;
        }
    }

    replaceChars = (maskedCardNumber) => {
        let reg = /.{1,8}/;
        return maskedCardNumber.replace(reg, (m) => "X".repeat(m.length));
    }

    render() {
        const { classes, t } = this.props;
        const { paymentMethods } = this.state;
        return (
            <div>
                {
                    paymentMethods && paymentMethods.length <= 0 ? (
                        <label className={classes.noPaymentFound}>{t("Patient.Payment.NoPaymentMethodFound")}</label>
                    ) : (
                            <div>
                                <Grid container className={classes.root} spacing={16}>
                                    <Grid item xs={12}>
                                        <Grid container className={classes.demo} spacing={16}>
                                            {
                                                paymentMethods && paymentMethods.map && paymentMethods.map(item => {
                                                    return (
                                                        <Grid key={item.id} item>
                                                            <Paper className={classes.paper}>
                                                                <div>
                                                                    {this.getCardImageByCardBrand(item.card_brand)}
                                                                </div>
                                                                <div>
                                                                    <label style={{fontSize: '15px', fontWeight: 400}}>{this.replaceChars(item.masked_card_number)}</label>
                                                                </div>
                                                            </Paper>
                                                        </Grid>
                                                    )
                                                })
                                            }
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </div>
                        )
                }
            </div>
        );
    }
}

PatientHistory.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(withTranslation()(PatientHistory));



// WEBPACK FOOTER //
// ./src/components/patient-list/paymentMethods.js